import './Timeline.css';

const Timeline = ({ experiences, onExperienceClick }) => {

  return (
    <div className="timeline-container">
      <h2>Experience</h2>
      <div className="timeline">
        {experiences.map((exp, index) => (
          <div key={index} className="timeline-item clickable" onClick={() => onExperienceClick(exp)}>
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <img src={exp.logo} alt={exp.company} className="timeline-logo" />
                <div className="timeline-info">
                  <h3 className="timeline-role">{exp.role}</h3>
                  <h4 className="timeline-company">{exp.company}</h4>
                  <span className="timeline-date">{exp.date}</span>
                </div>
              </div>
              <p className="timeline-description">{exp.description}</p>
              
              <div className="timeline-skills">
                {exp.skills.slice(0, 4).map((skill, idx) => (
                  <span key={idx} className="timeline-skill">{skill}</span>
                ))}
                {exp.skills.length > 4 && <span className="timeline-skill-more">+{exp.skills.length - 4}</span>}
              </div>
              
              <div className="timeline-click-hint">Click to view details →</div>
            </div>
          </div>
        ))}
      </div>


    </div>
  );
};

export default Timeline;